import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { commonIconClassName } from './common';

export const AlarmClock = ({ className }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24">
    <path
      d="M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z"
      className="fill-current opacity-12"
    />
    <path
      d="M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M9 13.5L11 15.5L15.5 11M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84286 8.84344 4 10.8783 4 13C4 15.1217 4.84286 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const StepReminder = ({ className }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24">
    <path
      d="M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z"
      className="fill-current opacity-12"
    />
    <path
      d="M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M12 9V13L14 15M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ClockCheck = ({ className }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      className="fill-current opacity-12"
    />
    <path
      d="M14.5 19L16.5 21L21 16.5M21.9851 12.5499C21.995 12.3678 22 12.1845 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.4354 6.33651 21.858 11.7385 21.9966M12 6V12L15.7384 13.8692"
      className="fill-none stroke-current"
    />
  </svg>
);

export const CalendarDate = ({ className }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24">
    <path
      d="M3 8.8C3 7.11984 3 6.27976 3.32698 5.63803C3.6146 5.07354 4.07354 4.6146 4.63803 4.32698C5.27976 4 6.11984 4 7.8 4H16.2C17.8802 4 18.7202 4 19.362 4.32698C19.9265 4.6146 20.3854 5.07354 20.673 5.63803C21 6.27976 21 7.11984 21 8.8V10H3V8.8Z"
      className="fill-current opacity-12"
    />
    <path
      d="M21 10H3M16 2V6M8 2V6M10.5 14L12 13V18M10.75 18H13.25M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const CalendarHeart02 = ({ className }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24">
    <path
      d="M3 8.8C3 7.11984 3 6.27976 3.32698 5.63803C3.6146 5.07354 4.07354 4.6146 4.63803 4.32698C5.27976 4 6.11984 4 7.8 4H16.2C17.8802 4 18.7202 4 19.362 4.32698C19.9265 4.6146 20.3854 5.07354 20.673 5.63803C21 6.27976 21 7.11984 21 8.8V10H3V8.8Z"
      className="fill-current opacity-12"
    />
    <path
      clipRule="evenodd"
      d="M17.4976 15.7119C16.7978 14.9328 15.6309 14.7232 14.7541 15.4367C13.8774 16.1501 13.7539 17.343 14.4425 18.1868C15.131 19.0306 17.4976 21 17.4976 21C17.4976 21 19.8642 19.0306 20.5527 18.1868C21.2413 17.343 21.1329 16.1426 20.2411 15.4367C19.3492 14.7307 18.1974 14.9328 17.4976 15.7119Z"
      className="fill-current opacity-12"
    />

    <path
      d="M21 10H3M21 11.5V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22H12.5M16 2V6M8 2V6M17.4976 15.7119C16.7978 14.9328 15.6309 14.7232 14.7541 15.4367C13.8774 16.1501 13.7539 17.343 14.4425 18.1868C15.131 19.0306 17.4976 21 17.4976 21C17.4976 21 19.8642 19.0306 20.5527 18.1868C21.2413 17.343 21.1329 16.1426 20.2411 15.4367C19.3492 14.7307 18.1974 14.9328 17.4976 15.7119Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ClockRewind = ({ className }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24">
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      className="fill-current opacity-12"
    />
    <path
      d="M22.7 13.5L20.7005 11.5L18.7 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C15.3019 3 18.1885 4.77814 19.7545 7.42909M12 7V12L15 14"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ClockPlus = ({ className }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      className="fill-current opacity-12"
    />
    <path
      d="M21.9208 13.265C21.9731 12.8507 22 12.4285 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.4354 22 12.8643 21.9722 13.285 21.9182M12 6V12L15.7384 13.8692M19 22V16M16 19H22"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ClockRight02 = ({ className }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      className="fill-current opacity-12"
    />
    <path
      d="M21.9208 13.265C21.9731 12.8507 22 12.4285 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.4354 22 12.8643 21.9722 13.285 21.9182M12 6V12L15.7384 13.8692M19 22L22 19M19 16L22 19M16 19C18 19 20 19 22 19"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ClockLeft02 = ({ className }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      className="fill-current opacity-12"
    />
    <path
      d="M21.9208 13.265C21.9731 12.8507 22 12.4285 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.4354 22 12.8643 21.9722 13.285 21.9182M12 6V12L15.7384 13.8692"
      className="fill-none stroke-current"
    />
    <path d="M18.625 21L16 18.5M16 18.5L18.625 16M16 18.5H22" className="fill-none stroke-current" />
  </svg>
);

export const Hourglass01 = ({ className }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24">
    <path
      d="M6 19.2482V22H18V19.2482C18 18.4218 18 18.0086 17.897 17.6257C17.8057 17.2865 17.6556 16.9659 17.4534 16.6786C17.2252 16.3543 16.9077 16.0898 16.2729 15.5607L12 12L7.72711 15.5607C7.09226 16.0898 6.77484 16.3543 6.54664 16.6786C6.34444 16.9659 6.19429 17.2865 6.10301 17.6257C6 18.0086 6 18.4218 6 19.2482Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 12L7.72711 8.43926C7.09226 7.91022 6.77484 7.6457 6.54664 7.32144C6.34444 7.03413 6.19429 6.71354 6.10301 6.37428C6 5.99139 6 5.57819 6 4.7518V2M12 12L16.2729 8.43926C16.9077 7.91022 17.2252 7.6457 17.4534 7.32144C17.6556 7.03413 17.8057 6.71354 17.897 6.37428C18 5.99139 18 5.57819 18 4.7518V2M12 12L7.72711 15.5607C7.09226 16.0898 6.77484 16.3543 6.54664 16.6786C6.34444 16.9659 6.19429 17.2865 6.10301 17.6257C6 18.0086 6 18.4218 6 19.2482V22M12 12L16.2729 15.5607C16.9077 16.0898 17.2252 16.3543 17.4534 16.6786C17.6556 16.9659 17.8057 17.2865 17.897 17.6257C18 18.0086 18 18.4218 18 19.2482V22M4 2H20M4 22H20"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ClockRefresh = ({ className }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24">
    <path
      d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z"
      className="fill-current opacity-12"
    />
    <path
      d="M20.4535 12.8928C20.1757 15.5027 18.6969 17.9484 16.2499 19.3612C12.1844 21.7084 6.98592 20.3155 4.63871 16.25L4.38871 15.817M3.54642 11.1071C3.82422 8.49723 5.30301 6.05151 7.75 4.63874C11.8155 2.29153 17.014 3.68447 19.3612 7.74995L19.6112 8.18297M3.49342 18.0659L4.22547 15.3339L6.95752 16.0659M17.0425 7.93398L19.7745 8.66603L20.5066 5.93398M12 7.49995V12L14.5 13.5"
      className="fill-none stroke-current"
    />
  </svg>
);
